module.exports = __webpack_public_path__ + "static/media/team4.82173e7c.png";